import { Grid, withStyles } from '@material-ui/core';
import axios from 'axios';
import { uniq } from 'lodash';
import moment from 'moment';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { DateFnsFormats, formatAs, formatDateRange, getAsLongDate, getCurrentUkgUserDateTime } from '../../../common-client2/src/services/ukgDateTime';
import EmploymentBillboard from '../../App/index';
import * as aux from '../../auxilaries';
import { EXCLUDED_HYPERFIND_IDS, REQUEST_PAGE_DEFAULT_HYPERFIND, REQUEST_PAGE_DEFAULT_SELECTED_STATUS } from '../../constants';
import { getSymbolicPeriodList } from '../../services/api-endpoints';
import { ManagerDashboardStyles } from '../../styles/styles';
import { currentHttpOptions, MomentFormats } from '../../utils';
import { defaultEmployeeColumnsLeft, defaultEmployeeColumnsRight, defaultRequestColumns } from './constants';
import DataviewTable from './DataviewTable';
import ManagerTopBar from './ManagerTopBar';
import RequestTable from './RequestTable';

import {
    clearFilters,
    initUpdate,
    rerenderTopBar,
    updateDataviewColumns,
    updateDataviewsList,
    updateDates,
    updateFetchSizeOption,
    updateFilterDataview,
    updateHyperfindQuery,
    updateManagerData,
    updateSearchDateType,
    updateSearchQuery,
    updateSelectedManagerSettings,
    updateSelectedManagerSettingsAndDataview,
    updateSelectedStatus,
} from './actions';

import { faArchive } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RequestTypes } from '../../Enums';

const parseHyperfindQueries = (hyperfindQueries) => {
    let newHyperfindQueries = [];
    for (let query of hyperfindQueries) {
        if (EXCLUDED_HYPERFIND_IDS.includes(query.id)) {
            continue;
        }
        newHyperfindQueries.push({
            value: query.id,
            label: query.name,
            desc: query.description,
            visibility: query.visibility
        })
    }
    return newHyperfindQueries;
}

const hasAwarding = (setting) => (setting.type === RequestTypes.voluntaryTimeOff || setting.type === RequestTypes.openShift) && setting.adminSettings[0].isSignUp;

const formatRequest = (request) => ({
    ...request,
    detailPanel: true,
    messages: request.history.filter(x => x.message)
});

class ManagerDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openShiftEnabled: true,
            tableActions: [{ label: "Approve Request", value: 'approve', disabled: true }, { label: "Pending Request", value: 'pending', disabled: true }, { label: "Refuse Request", value: 'refuse', disabled: true }],
            spinnerShow: false,
            isLoading: true,
            typeSnackbar: 'success',
            messageSnackbar: '',
            openSnackbar: false,
            personNumber: 0,
            initLoad: true,
            addMoreDisable: false,
            checkedRequests: [],
            searchData: {
                searchType: 0,
                startDate: formatAs(getCurrentUkgUserDateTime(new Date()), DateFnsFormats.YMD),
                endDate: formatAs(getCurrentUkgUserDateTime(new Date()), DateFnsFormats.YMD),
                hyperfindId: 1,

                searchString: null,
                statusFilterList: null,
                managerSettingIds: null,
            },
            fetchResultData: {
                viewed: 0,
                total: 0
            }
        }
        document.title = this.props.t('settings.pageTitle.manager');
        this.init();
    }

    init = () => {
        const options = currentHttpOptions();
        this.setState({ isLoading: true });

        axios.all([
            getSymbolicPeriodList(),
            axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/common/GetHyperFindQueries', options),
            axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/GetAllSettings?view=2', options),
            axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/Dataview/GetDataviewsList', options),
        ]).then(axios.spread(async (periodsResponses, hyperfindQueriesResponses, managerSettings, dataviewList) => {

            const defaultPeriodSelectedSymbolicId = "Current_SchedPeriod";
            let defaultPeriodSelected = {};
            let newSchedulePeriod = {};
            let managerSettingsList = [];

            if (periodsResponses.data.length > 0) {
                for (let period of periodsResponses.data) {
                    period['label'] = period.name;
                    newSchedulePeriod[period.name.toString()] = [moment.utc(period.startDate), moment.utc(period.endDate)]
                    if (period.symbolicId === defaultPeriodSelectedSymbolicId) {
                        defaultPeriodSelected = period;
                    }
                }
            }

            this.props.updateDataviewsList(dataviewList.data.map(x => ({ ...x, label: x.name, value: x.id })));

            if (managerSettings.data.length > 0) {
                for (const setting of managerSettings.data) {
                    managerSettingsList.push({
                        ...setting,
                        label: setting.name,
                        value: setting.aggregateRootId,
                        visible: true,
                        multiSelectLogo: setting.isArchive ? <FontAwesomeIcon style={{ paddingRight: "5px" }} icon={faArchive} /> : undefined
                    })
                }
            }

            managerSettingsList.sort((a, b) => {
                if (a.isArchive === b.isArchive) {
                    return a.label.localeCompare(b.label);
                } else if (a.isArchive) {
                    return 1;
                } else {
                    return -1;
                }
            });

            const includedHyperfindOptions = parseHyperfindQueries(hyperfindQueriesResponses.data);
            await this.props.initUpdate({
                hyperFindQueries: includedHyperfindOptions,
                ranges: newSchedulePeriod,
                periodSelected: defaultPeriodSelected,
                periods: periodsResponses.data,
                dateRanges: {
                    startDate: moment.utc(defaultPeriodSelected.startDate, MomentFormats.YMD),
                    endDate: moment.utc(defaultPeriodSelected.endDate, MomentFormats.YMD),
                },
                managerSettingsList: managerSettingsList,
                //reset filters
                selectedHyperfind: REQUEST_PAGE_DEFAULT_HYPERFIND,
                searchQuery: '',
                resetSearchQuery: true,
                selectedManagerSetting: [],
                statusFilterList: REQUEST_PAGE_DEFAULT_SELECTED_STATUS,
                selectedSearchDateType: { label: "Date submitted descending", value: 2 }
            })
            await this.refreshAllData();

            this.setState({
                personNumber: sessionStorage.getItem('PersonNumber'),
                isLoading: false
            });

        })).catch((err) => {
            this.setState({ isLoading: false });
            this.handleSnackbar('error', err.response && err.response.data ? JSON.stringify(err.response.data) : err.error?.toString(), true)
        })
    }


    handleEventDate = (_, picker) => {
        let foundSelectedPeriod = this.props.periods.find((element) => {
            return element.name === picker.chosenLabel
        })

        if (foundSelectedPeriod === undefined && picker.chosenLabel === "Custom Range") {
            const startDate = picker.startDate.toDate();
            const endDate = picker.endDate.toDate();
            const label = formatDateRange(startDate, endDate, getAsLongDate);
            foundSelectedPeriod = {
                startDate: formatAs(startDate, DateFnsFormats.YMD),
                endDate: formatAs(endDate, DateFnsFormats.YMD),
                label: label,
                value: label,
                name: label
            }
        }

        this.props.updateDates({
            periodSelected: foundSelectedPeriod,
            dateRanges: {
                startDate: foundSelectedPeriod.startDate,
                endDate: foundSelectedPeriod.endDate,
            }
        });
    }

    handleSelectHyperfind = (_, value) => {
        this.props.updateHyperfindQuery({
            selectedHyperfind: value,
        });
    }
    sortList(listRequests) {
        if (!listRequests) return listRequests

        listRequests.sort(function (req1, req2) {
            let req1OfferDate = req1.actionType === RequestTypes.shiftSwap ? req1.submissionDate.substring(0, 10) : req1.requestDate.substring(0, 10)
            let req2OfferDate = req2.actionType === RequestTypes.shiftSwap ? req2.submissionDate.substring(0, 10) : req2.requestDate.substring(0, 10)
            let req1OfferTime = req1.actionType === RequestTypes.shiftSwap ? req1.submissionDate.substring(11, 19) : req1.requestDate.substring(11, 19)
            let req2OfferTime = req2.actionType === RequestTypes.shiftSwap ? req2.submissionDate.substring(11, 19) : req2.requestDate.substring(11, 19)

            if (req1OfferDate > req2OfferDate) return -1 //date1>date2: date2->bot
            else if (req1OfferDate < req2OfferDate) return 1
            else if (req1.requestType.toLowerCase() > req2.requestType.toLowerCase()) return 1//'z'>'a': a->top
            else if (req1.requestType.toLowerCase() < req2.requestType.toLowerCase()) return -1
            else if (req1OfferTime > req2OfferTime) return -1//time1>time2: 2->bot
            else if (req1OfferTime < req2OfferTime) return 1
            else return 0
        })
        return listRequests
    }

    addMoreRequests = async () => {
        let { offset, selectedFetchSize, data, updateManagerData } = this.props;

        //Api with batch call
        this.handleSpinner(true);
        this.fetchData(offset, selectedFetchSize.value, async (responseData) => {
            var listRequests = [];
            if (responseData) {
                for (const req of responseData.requests) {
                    listRequests.push(formatRequest(req));
                }
            }

            await updateManagerData({
                data: [...data, ...listRequests],
                offset: offset + selectedFetchSize.value
            });

        });
    }

    refreshData = (requestIds) => {
        let { dateRanges, selectedHyperfind, selectedSearchDateType, updateManagerData, offset } = this.props;
        let options = currentHttpOptions();

        this.handleSpinner(true);

        axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/request/GetSpecificRequests", {
            searchType: selectedSearchDateType.value,
            startDate: dateRanges.startDate,
            endDate: dateRanges.endDate,
            hyperfindId: selectedHyperfind.value,
            requestIds: requestIds
        }, options).then(async (response) => {
            let { data } = this.props;

            let newData = data.map((x) => {
                let res = response.data.requests.find(y => (
                    (y.offerId && x.offerId && y.offerId === x.offerId && x.submissionDate === y.submissionDate) ||
                    (y.requestId && x.requestId && y.requestId === x.requestId)
                ) &&
                    (x.status.value === 1 || x.status.value === 7));

                if (res) {
                    return formatRequest(res);
                } else {
                    return x;
                }
            });

            await updateManagerData({
                data: newData,
                offset: offset
            });

        }).catch(err => {
            let message = aux.handleAPIErrors(err.response);
            this.handleSnackbar('error', message, true);
        }).finally(() => {
            this.handleSpinner(false);
        });

    }


    refreshAllData = async (fetchSize) => {
        let { dateRanges, selectedHyperfind, selectedManagerSetting, selectedStatus, selectedSearchDateType, selectedFetchSize, searchQuery, updateManagerData } = this.props;
        this.handleSpinner(true);

        if (!fetchSize) {
            fetchSize = selectedFetchSize.value;
        }

        let selectedStatusIds = selectedStatus.map(x => x.value);
        let selectedManagerSettingsGuids = selectedManagerSetting.map(x => x.aggregateRootId);
        let searchData = {
            searchType: selectedSearchDateType.value,
            startDate: dateRanges.startDate,
            endDate: dateRanges.endDate,
            hyperfindId: selectedHyperfind.value,
            searchString: searchQuery.length ? searchQuery : null,
            statusFilterList: selectedStatusIds.length ? selectedStatusIds : null,
            managerSettingIds: selectedManagerSettingsGuids.length ? selectedManagerSettingsGuids : null,
        }

        await updateManagerData({
            data: [],
            offset: 0
        });

        this.setState({
            searchData: searchData,
            fetchResultData: {
                viewed: 0,
                total: 0
            }
        }, () => {
            this.fetchData(0, fetchSize, async (data) => {
                let listRequests = [];

                if (data) {
                    if (data.requests.length) {
                        for (const req of data.requests) {
                            listRequests.push(formatRequest(req));
                        }
                    }
                }

                await updateManagerData({
                    data: listRequests,
                    offset: fetchSize
                });

                this.setState({
                    checkedRequests: [],
                });
            });
        });

        if (selectedManagerSetting.length === 1) {
            let managerSetting = selectedManagerSetting[0];
            const options = currentHttpOptions()
            axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/ManagerSettings/ExecuteDataview", {
                SearchType: this.props.selectedSearchDateType.value,
                ManagerSettingId: managerSetting.adminSettings[0].managerEntityId,
                FromDate: moment.utc(dateRanges.startDate).format(MomentFormats.YMD),
                ToDate: moment.utc(dateRanges.endDate).format(MomentFormats.YMD)
            }, options).then(async (response) => {
                let message = aux.handleAPIErrors(response);
                if (message) {
                    this.handleSnackbar('error', message, true)
                } else {
                    const { dataviewsList, updateSelectedManagerSettingsAndDataview } = this.props
                    let employee1Columns = [...defaultEmployeeColumnsLeft];
                    let employee2Columns = [...defaultEmployeeColumnsLeft];
                    let dataview = ''
                    if (managerSetting && managerSetting.adminSettings[0].dataviewId) {
                        dataview = dataviewsList.find(x => x.id === managerSetting.adminSettings[0].dataviewId);
                        if (dataview) {
                            for (let x of dataview.fields) {
                                employee1Columns.push({ "Label": x.label, "Optional": true, "Active": managerSetting.adminSettings[0].dataviewDisplayedCols.includes(x.key), "Dataview": true, "DataviewKey": x.key });
                                employee2Columns.push({ "Label": x.label, "Optional": true, "Active": managerSetting.adminSettings[0].dataviewDisplayedCols.includes(x.key), "Dataview": true, "DataviewKey": x.key });
                            }
                        }
                    }

                    if (managerSetting.type === 3 || managerSetting.type === 2) {
                        employee1Columns.push({ "Label": "Award status", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__AWARDING" })
                        employee1Columns.push({ "Label": "Seniority rank", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__SENIORITY" })
                    }

                    //push Shift column to the left of dataview columns
                    employee1Columns = employee1Columns.concat(defaultEmployeeColumnsRight);
                    employee2Columns = employee2Columns.concat(defaultEmployeeColumnsRight);

                    await updateSelectedManagerSettingsAndDataview({
                        currentDataview: dataview,
                        dataviewsData: response.data,
                        dataviewRequestColumns: [...defaultRequestColumns],
                        dataviewEmployee1Columns: employee1Columns,
                        dataviewEmployee2Columns: employee2Columns,
                    })
                }
            }).catch(err => {
                let message = aux.handleAPIErrors(err.response)
                this.handleSnackbar('error', message, true)
                this.handleSpinner(false)
            });
        }
    }

    downloadOpenShiftReportAsExcel = async () => {
        let { searchData } = this.state;
        const { dataviewEmployee1Columns, selectedManagerSetting } = this.props;
        let options = {
            headers: {
                Authorization: sessionStorage.getItem('authToken') ?? '',
            },
            responseType: 'arraybuffer',
        };

        let managerSetting = null
        if (selectedManagerSetting.length == 1 && selectedManagerSetting[0]?.type == 2) {
            managerSetting = selectedManagerSetting[0].adminSettings[0].managerEntityId;
        }
        try {
            const response = await axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/request/GetOpenShiftReportAsExcel", {
                startDate: searchData.startDate,
                endDate: searchData.endDate,
                managerSettingId: managerSetting,
            }, options);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Open Shift report.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            var errorData = JSON.parse(new TextDecoder().decode(err.response.data));
            this.handleSnackbar('error', errorData.Message, true);
        }
    }

    downloadDataAsExcel = async () => {
        let { searchData } = this.state;
        const { dataviewEmployee1Columns } = this.props;
        let options = {
            headers: {
                Authorization: sessionStorage.getItem('authToken') ?? '',
            },
            responseType: 'arraybuffer',
        };
        try {
            const response = await axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/request/GetRequestsAsExcel", {
                requestParameters: {
                    searchType: searchData.searchType,
                    startDate: searchData.startDate,
                    endDate: searchData.endDate,
                    hyperfindId: searchData.hyperfindId,

                    searchString: searchData.searchString,
                    statusFilterList: searchData.statusFilterList,
                    managerSettingIds: searchData.managerSettingIds,
                },
                optionalDataviewParameters: {
                    dataviewEmployee1Columns: !!dataviewEmployee1Columns ? dataviewEmployee1Columns.filter(x => x.Optional && x.Active)
                        .map(x => ({ KeyAlias: x.DataviewKey, Label: x.Label })) : [],
                }
            }, options);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Request dashboard report.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            var errorData = JSON.parse(new TextDecoder().decode(err.response.data));
            this.handleSnackbar('error', errorData.Message, true);
        };
    }

    fetchData = async (offset, fetchSize, successCallBack) => {
        let { searchData, fetchResultData } = this.state;
        let options = currentHttpOptions();
        if (searchData.hyperfindId == null) { // Hyperfind is "None"
            this.handleSpinner(false);
            return;
        }

        axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/request/getRequests", {
            searchType: searchData.searchType,
            startDate: searchData.startDate,
            endDate: searchData.endDate,
            hyperfindId: searchData.hyperfindId,

            searchString: searchData.searchString,
            statusFilterList: searchData.statusFilterList,
            managerSettingIds: searchData.managerSettingIds,

            fetchSize: fetchSize,
            offset: offset
        }, options).then(async (response) => {
            successCallBack(response.data);

            fetchResultData.viewed = fetchResultData.viewed + response.data.requests.length;
            if (response.data.totalCount) {
                fetchResultData.total = response.data.totalCount;
            }

            if (fetchResultData.viewed < fetchResultData.total) {
                this.setState({
                    addMoreDisable: false,
                    fetchResultData: fetchResultData
                });
            } else {
                this.setState({
                    addMoreDisable: true,
                    fetchResultData: fetchResultData
                });
            }
        }).catch(err => {
            let message = aux.handleAPIErrors(err.response);
            this.handleSnackbar('error', message, true);
        }).finally(() => {
            this.handleSpinner(false);
        });

    }

    handleRecalculateAwarding = (type, openShiftKey) => {
        const { selectedManagerSetting, data } = this.props
        if (type === 'VTO') {
            if (selectedManagerSetting.length === 1) {
                let setting = selectedManagerSetting[0];
                const isVto = setting.type === RequestTypes.voluntaryTimeOff;

                if (isVto) {
                    let requestIds = data.filter(x => x.managerSettingAggregateRootId === setting.aggregateRootId).map(x => x.requestId);
                    this.handleSpinner(true);
                    let options = currentHttpOptions()
                    axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/voluntaryTimeOffManager/CalculateAwardingRanks", {
                        ManagerSettingId: setting.hyperfindSettings[0].managerEntityId
                    }, options).then((response) => {
                        let message = aux.handleAPIErrors(response);
                        if (message) {
                            this.handleSnackbar('error', message, true)
                        }
                        this.refreshData(requestIds);
                    }).catch(err => {
                        let message = aux.handleAPIErrors(err.response)
                        this.handleSnackbar('error', message, true)
                        this.handleSpinner(false)
                    });
                }

            }
        } else if (type === 'OS') {
            if (selectedManagerSetting.length === 1) {
                let setting = selectedManagerSetting[0];
                const isOpenShift = setting.type === RequestTypes.openShift;

                if (isOpenShift) {
                    let requestIds = data.filter(x => x.openShiftKey === openShiftKey).map(x => x.requestId);

                    this.handleSpinner(true);
                    let options = currentHttpOptions()
                    axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/OpenShiftManager/CalculateAwardingRanks", {
                        ManagerSettingId: setting.hyperfindSettings[0].managerEntityId,
                        OpenShiftKey: openShiftKey,
                    }, options).then((response) => {
                        let message = aux.handleAPIErrors(response);
                        if (message) {
                            this.handleSnackbar('error', message, true)
                        }
                        this.refreshData(requestIds)
                    }).catch(err => {
                        let message = aux.handleAPIErrors(err.response)
                        this.handleSnackbar('error', message, true)
                        this.handleSpinner(false)
                    });
                }
            }
        }
    }

    handleSpinner = (spinnerShow) => {
        this.setState({
            spinnerShow: spinnerShow,
        })
    }

    handleSnackbar = (type, message, openState) => {
        this.setState({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
            spinnerShow: false,
        })
    }

    closeSnackbar = () => {
        this.setState({ openSnackbar: false });
    }

    /**
     * @param {{
     *  toCover: string;
     *  shiftSwap: string;
     *  openShift: string;
     *  vto: string;
     * }} actionEndpoints
     * @param {string} message
     */
    submitAction = (actionEndpoints, message) => {
        const { data } = this.props

        let selectedRequests = data.filter(rowData => rowData.tableData && rowData.tableData.checked && !rowData.tableData.disabled)
        if (selectedRequests.length === 0)
            return
        this.handleSpinner(true)
        const options = currentHttpOptions()

        let toCoverList = [];
        let swapList = [];
        let openList = [];
        let timeOffList = [];
        let openShiftKeys = new Set();

        selectedRequests.forEach(request => {
            switch (request.actionType) {
                case RequestTypes.toCover:
                    toCoverList.push(request.offerId);
                    break;
                case RequestTypes.shiftSwap:
                    swapList.push(request.offerId);
                    break;
                case RequestTypes.openShift:
                    openList.push(request.requestId);
                    openShiftKeys.add(request.openShiftKey);
                    break;
                case RequestTypes.voluntaryTimeOff:
                    timeOffList.push(request.requestId);
                    break;
            }
        });

        let allOpenShiftRequestIds = [];
        if (openShiftKeys.size > 0) {
            const openShiftKeysArray = Array.from(openShiftKeys);
            allOpenShiftRequestIds = data
                .filter(x => openShiftKeysArray.includes(x.openShiftKey) && x.actionType === RequestTypes.openShift)
                .map(x => x.requestId);
        }

        let idsToBeReloadedAfter = [
            ...toCoverList,
            ...swapList,
            ...allOpenShiftRequestIds,
            ...timeOffList
        ];

        let axiosRequests = []

        if (toCoverList.length > 0) {
            axiosRequests.push(axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/manager/requestToCover/${actionEndpoints.toCover}`, {
                offerIds: toCoverList, message
            }, options))
        }
        if (swapList.length > 0) {
            axiosRequests.push(axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/manager/shiftSwapManager/${actionEndpoints.shiftSwap}`, {
                offersId: swapList, message
            }, options))
        }
        if (openList.length > 0) {
            axiosRequests.push(axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/manager/openShiftManager/${actionEndpoints.openShift}`, {
                requestIds: openList, message
            }, options))
        }
        if (timeOffList.length > 0) {
            axiosRequests.push(axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/manager/voluntaryTimeOffManager/${actionEndpoints.vto}`, {
                requestIds: timeOffList, message
            }, options))
        }

        axios.all(axiosRequests).then(async responses => {
            let hasErrors = false
            // eslint-disable-next-line array-callback-return
            let message = responses.map(response => {
                let errorMessage = aux.handleAPIErrors(response)
                if (errorMessage) {
                    hasErrors = true
                    return <div>{errorMessage}</div>
                }
            })
            if (hasErrors) {
                this.handleSnackbar('error', message, true)
            }


        }).catch(err => {
            let message = aux.handleAPIErrors(err.response)
            this.handleSnackbar('error', message, true)
            this.handleSpinner(false)
        }).finally(() => {
            this.refreshData(idsToBeReloadedAfter);
        });
    }

    handleSelectFetchSize = async (_, value) => {
        await this.props.updateFetchSizeOption({
            selectedFetchSize: value,
        });
    }

    handleSelectSearchDateType = async (_, value) => {
        await this.props.updateSearchDateType(value)
    }

    handleSelectStatus = async (_, value) => {
        await this.props.updateSelectedStatus(value);
    }

    handleSelectManagerSetting = async (_, managerSettings) => {
        await this.props.updateSelectedManagerSettings(managerSettings);
    }


    handleSearchQuery = async (_, value) => {
        await this.props.updateSearchQuery(value);
    }

    handleFilterDataview = (req, emp1, emp2, newDataview) => {
        const { updateFilterDataview, updateDataviewColumns, selectedManagerSetting, currentDataview, dateRanges } = this.props
        const options = currentHttpOptions()
        if (currentDataview === newDataview) {
            updateDataviewColumns({
                dataviewRequestColumns: req,
                dataviewEmployee1Columns: emp1,
                dataviewEmployee2Columns: emp2,
            })
        } else {
            let selectedAdminSetting = selectedManagerSetting[0].adminSettings.find(setting => setting.dataviewId === currentDataview.id)
            axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/manager/ManagerSettings/ExecuteDataview", {
                ManagerSettingId: selectedAdminSetting.managerEntityId,
                FromDate: moment.utc(dateRanges.startDate).format(MomentFormats.YMD),
                ToDate: moment.utc(dateRanges.endDate).format(MomentFormats.YMD)
            }, options).then((response) => {
                let message = aux.handleAPIErrors(response);
                if (message) {
                    this.handleSnackbar('error', message, true)
                } else {
                    updateFilterDataview({
                        currentDataview: newDataview,
                        dataviewRequestColumns: req,
                        dataviewEmployee1Columns: emp1,
                        dataviewEmployee2Columns: emp2,
                    })
                }
            }).catch(err => {
                let message = aux.handleAPIErrors(err.response)
                this.handleSnackbar('error', message, true)
                this.handleSpinner(false)
            });
        }
    }

    onCheckedRequest = (rows) => {
        const { data } = this.props;
        let selectedRequests = data.filter(rowData => rowData.tableData && rowData.tableData.checked && !rowData.tableData.disabled);
        this.setState({
            checkedRequests: selectedRequests,
        })
        this.props.rerenderTopBar();
    }

    generateTable = (managerSetting, activeSubmissionPeriodSettingsWithAwarding, signUpRequestSelected, isNonActiveSignUpRequestSelected, showDataviewBtn) => {
        const { data } = this.props
        const { addMoreDisable, fetchResultData } = this.state;
        let holder;

        if (showDataviewBtn) {
            if (managerSetting.type === RequestTypes.openShift) {
                holder = [];

                data.sort((a, b) => {
                    if (moment.parseZone(a.shift.startDateTime).toISOString() < moment.parseZone(b.shift.startDateTime).toISOString())
                        return 1
                    else if (moment.parseZone(a.shift.startDateTime).toISOString() > moment.parseZone(b.shift.startDateTime).toISOString())
                        return -1
                    else return 0
                });

                let keys = uniq(data.map(x => x.openShiftKey));

                for (let key of keys) {

                    let dataWithKey = data.filter(x => x.openShiftKey === key)

                    holder.push(<Grid item xs={12}>
                        <DataviewTable
                            data={dataWithKey}
                            managerSetting={managerSetting}
                            activeSubmissionPeriodSettingsWithAwarding={activeSubmissionPeriodSettingsWithAwarding}
                            signUpRequestSelected={signUpRequestSelected}
                            isNonActiveSignUpRequestSelected={isNonActiveSignUpRequestSelected}
                            onCheckedRequest={this.onCheckedRequest}
                            handleRecalculateAwarding={this.handleRecalculateAwarding}
                            OpenShiftKeyTable={true}
                            addMoreRequests={this.addMoreRequests}
                            addMoreDisable={addMoreDisable}
                            fetchResultData={fetchResultData}
                        />
                    </Grid>);
                }
            } else {
                holder = <Grid item xs={12} >
                    <DataviewTable
                        data={data}
                        managerSetting={managerSetting}
                        activeSubmissionPeriodSettingsWithAwarding={activeSubmissionPeriodSettingsWithAwarding}
                        signUpRequestSelected={signUpRequestSelected}
                        isNonActiveSignUpRequestSelected={isNonActiveSignUpRequestSelected}
                        onCheckedRequest={this.onCheckedRequest}
                        addMoreRequests={this.addMoreRequests}
                        addMoreDisable={addMoreDisable}
                        fetchResultData={fetchResultData}
                    />
                </Grid>;
            }
        } else {
            holder = <Grid item xs={12}>
                <RequestTable
                    activeSubmissionPeriodSettingsWithAwarding={activeSubmissionPeriodSettingsWithAwarding}
                    signUpRequestSelected={signUpRequestSelected}
                    isNonActiveSignUpRequestSelected={isNonActiveSignUpRequestSelected}
                    onCheckedRequest={this.onCheckedRequest}
                    addMoreRequests={this.addMoreRequests}
                    addMoreDisable={addMoreDisable}
                    fetchResultData={fetchResultData}
                />
            </Grid>;
        }

        return holder;
    }

    render() {
        let { classes, selectedManagerSetting, dataviewsList, managerSettingsList } = this.props;
        let { spinnerShow, messageSnackbar, openSnackbar, typeSnackbar, searchData, checkedRequests, isLoading } = this.state;

        let managerSetting = searchData.managerSettingIds ? managerSettingsList.find(x => searchData.managerSettingIds.includes(x.aggregateRootId)) : null;

        const currentTime = getCurrentUkgUserDateTime(new Date()).toISOString();
        const activeSubmissionPeriodSettingsWithAwarding = managerSettingsList.filter(x => hasAwarding(x) && currentTime < moment.utc(x.toCoverPeriod_EndDate)).map(y => y.aggregateRootId);
        const isActiveSignUpRequestSelected = checkedRequests.length ? checkedRequests.some(x => activeSubmissionPeriodSettingsWithAwarding.includes(x.managerSettingAggregateRootId)) : false;
        const isNonActiveSignUpRequestSelected = checkedRequests.length && checkedRequests.some(x => !activeSubmissionPeriodSettingsWithAwarding.includes(x.managerSettingAggregateRootId));
        const disableApprove = isActiveSignUpRequestSelected;
        const disablePending = isActiveSignUpRequestSelected;

        const showDataviewBtn = searchData.managerSettingIds && searchData.managerSettingIds.length === 1 && selectedManagerSetting.length > 0;
        const hideDownloadExcelButton = searchData.managerSettingIds && searchData.managerSettingIds.length === 1 && selectedManagerSetting.length > 0 && selectedManagerSetting[0].type !== RequestTypes.openShift;
        return (
            <EmploymentBillboard spinnerShow={spinnerShow} messageSnackbar={messageSnackbar} openSnackbar={openSnackbar} typeSnackbar={typeSnackbar} closeSnackbar={this.closeSnackbar} classes={classes.fullPage}>
                <ManagerTopBar
                    actionOptions={this.state.tableActions}
                    dataviewButton={showDataviewBtn}
                    isShowDownloadExcelButton={!hideDownloadExcelButton}
                    dataviewsList={managerSetting ? dataviewsList.filter(dataview => managerSetting.adminSettings.map(setting => setting.dataviewId).includes(dataview.id)) : []}
                    disableApprove={disableApprove}
                    disablePending={disablePending}
                    handleChangeDataview={this.handleChangeDataview}
                    handleEventDate={this.handleEventDate}
                    handleFilterDataview={this.handleFilterDataview}
                    handleManagerSetting={this.handleSelectManagerSetting}
                    handleRecalculateAwarding={this.handleRecalculateAwarding}
                    handleSearch={this.handleSearchQuery}
                    handleSelectHyperfind={this.handleSelectHyperfind}
                    handleSelectSearchDateType={this.handleSelectSearchDateType}
                    handleStatus={this.handleSelectStatus}
                    managerSetting={managerSetting}
                    refreshAllData={this.refreshAllData}
                    downloadDataAsExcel={this.downloadDataAsExcel}
                    downloadOpenShiftReportAsExcel={this.downloadOpenShiftReportAsExcel}
                    selectedManagerSettingStateName={"selectedManagerSetting"}
                    selectedStatusStateName={"selectedStatus"}
                    submitAction={this.submitAction}
                    handleSnackbar={this.handleSnackbar}
                    isLoading={isLoading}
                />
                <Grid container className={classes.fullPage}>
                    {this.generateTable(managerSetting, activeSubmissionPeriodSettingsWithAwarding, isActiveSignUpRequestSelected, isNonActiveSignUpRequestSelected, showDataviewBtn)}
                </Grid>
            </EmploymentBillboard>
        );
    }
}

const mapStateToProps = state => ({
    currentDataview: state.currentDataview,
    data: state.data,
    dataviewsList: state.dataviewsList,
    dateRanges: state.dateRanges,
    managerSettingsList: state.managerSettingsList,
    offset: state.offset,
    originalData: state.originalData,
    periods: state.periods,
    periodSelected: state.periodSelected,
    resetSearchQuery: state.resetSearchQuery,
    searchQuery: state.searchQuery,
    selectedFetchSize: state.selectedFetchSize,
    selectedHyperfind: state.selectedHyperfind,
    selectedManagerSetting: state.selectedManagerSetting,
    selectedSearchDateType: state.selectedSearchDateType,
    selectedStatus: state.selectedStatus,
    dataviewEmployee1Columns: state.dataviewEmployee1Columns,
});

const mapDispatchToProps = {
    clearFilters,
    initUpdate,
    updateDataviewColumns,
    updateDataviewsList,
    updateDates,
    updateFetchSizeOption,
    updateFilterDataview,
    updateHyperfindQuery,
    updateManagerData,
    updateSearchDateType,
    updateSearchQuery,
    updateSelectedManagerSettings,
    updateSelectedManagerSettingsAndDataview,
    updateSelectedStatus,
    rerenderTopBar,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ManagerDashboardStyles)(withTranslation('employmentBillboard')(ManagerDashboard)));